import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { URL } from "./apiurl";

export const handleGetProfileData = createAsyncThunk(
  "profileApi",
  async (payload) => {
    const response = await axios.post(URL.PhleboProfileData, {
      PhlebotomistID: payload.userId,
      CompanyId: payload.CompanyID,
    });
    return response.data;
  }
);

export const handleProfileImage = createAsyncThunk(
  "profileApi",
  async (payload) => {
    let formData = new FormData();
    formData.append("userid", payload?.userid);
    formData.append("CompanyID", payload?.CompanyID);
    formData.append("file", payload.image);
    formData.append("guid", payload?.guid);
    const response = await axios.post(
      "api/v1/HomeCollectionMobileApp/UpdateProfilePicture",
      formData
    );
    return response.data;
  }
);

const initialState = {
  error: false,
  loading: false,
  success: false,
  data: [],
};

export const getProfileData = createSlice({
  name: "profileSyncData",
  initialState: initialState,
  extraReducers: (builder) => {
    builder
      .addCase(handleGetProfileData.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(handleGetProfileData.fulfilled, (state, action) => {
        state.loading = false;
        const phelboData = action?.payload.message[0];
        state.data = phelboData ? phelboData : state.data;
      })
      .addCase(handleGetProfileData.rejected, (state, action) => {
        state.loading = false;
      });
  },
});

// this is for dispatch
export const { profileSyncData } = getProfileData.actions;

// this is for configureStore
export default getProfileData.reducer;
